import { render, staticRenderFns } from "./User-grade-review.vue?vue&type=template&id=447bafcd&scoped=true&"
import script from "./User-grade-review.vue?vue&type=script&lang=js&"
export * from "./User-grade-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447bafcd",
  null
  
)

export default component.exports